import { Box } from "@mui/material";

import { SingleTextFieldSubmit } from "@warden-ui/common-components";
import { CPLink } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

interface CardContentSignInPasswordProps {
  email: string;
  onClickSignin?: (password: string) => void;
  onClickForgotPassword?: () => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentSignInPassword = ({
  email,
  onClickSignin,
  onClickForgotPassword = () => {},
  ...props
}: CardContentSignInPasswordProps) => {
  const [ t ] = useTranslation();

  return (
    <CPCard>
      <SingleTextFieldSubmit
        title={t('signin_password.title')}
        hint={email}
        label={t('labels.enter_password')}
        textType="password"
        labelButton={t('buttons.next')}
        onClick={onClickSignin}
        capitalizeFirstLetterOnly={true}
        errorMessage={props.errorMessage}
        loading={props.loading}
      />

      <Box className="card-row mt-12">
        <CPLink
          label={t('signin_password.content.forgot_password')}
          onClick={onClickForgotPassword} />
      </Box>
    </CPCard>
  );
};
